"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVKFreezeFramePostedEvent = exports.AVKFreezeDataType = void 0;
var NEvent_1 = require("../NEvent");
var AVKFreezeDataType;
(function (AVKFreezeDataType) {
    AVKFreezeDataType[AVKFreezeDataType["FreezeDataTypeLeft"] = 0] = "FreezeDataTypeLeft";
    AVKFreezeDataType[AVKFreezeDataType["FreezeDataTypeRight"] = 1] = "FreezeDataTypeRight";
    AVKFreezeDataType[AVKFreezeDataType["FreezeDataTypeFullScreen"] = 2] = "FreezeDataTypeFullScreen";
})(AVKFreezeDataType = exports.AVKFreezeDataType || (exports.AVKFreezeDataType = {}));
var AVKFreezeFramePostedEvent = /** @class */ (function (_super) {
    __extends(AVKFreezeFramePostedEvent, _super);
    function AVKFreezeFramePostedEvent(channel, transferIdentifier, freezeType) {
        var _this = _super.call(this, channel) || this;
        _this._transferIdentifier = null;
        _this._freezeType = freezeType;
        _this._transferIdentifier = transferIdentifier;
        return _this;
    }
    AVKFreezeFramePostedEvent.universalModelType = function () {
        return 'io.avail.events.freezeframe.posted.v2';
    };
    Object.defineProperty(AVKFreezeFramePostedEvent.prototype, "transferIdentifier", {
        get: function () {
            return this._transferIdentifier;
        },
        set: function (value) {
            this._transferIdentifier = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVKFreezeFramePostedEvent.prototype, "freezeType", {
        get: function () {
            return this._freezeType;
        },
        set: function (value) {
            this._freezeType = value;
        },
        enumerable: false,
        configurable: true
    });
    return AVKFreezeFramePostedEvent;
}(NEvent_1.NEvent));
exports.AVKFreezeFramePostedEvent = AVKFreezeFramePostedEvent;
//# sourceMappingURL=AVKFreezeFramePostedEvent.js.map